import { render, staticRenderFns } from "./LeadCategoriesAndTags.vue?vue&type=template&id=48be244a&scoped=true"
import script from "./LeadCategoriesAndTags.vue?vue&type=script&lang=ts"
export * from "./LeadCategoriesAndTags.vue?vue&type=script&lang=ts"
import style0 from "./LeadCategoriesAndTags.vue?vue&type=style&index=0&id=48be244a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be244a",
  null
  
)

export default component.exports